import React, { useMemo, useState } from 'react'
import { useNotification } from '../../../../hooks/useNotification';
import { useErrorInputs } from '../../../../hooks/useErrorInputs';
import { useForm } from '../../../../hooks/useForm';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Dialog from '@mui/material/Dialog';
import Box from '@mui/material/Box';
import SettingsInputComponentIcon from '@mui/icons-material/SettingsInputComponent';
import EditNoteIcon from '@mui/icons-material/EditNote';
import Close from '@mui/icons-material/Close';
import { ActionButtons } from '../../../../components/others/ActionButtons';
import { ManageActions } from '../manageconfiguration/ManageActions';
import { safeParseJSON } from '../../../../utils/jsonValidator';
import { EMPTY_ACTION } from '../../constants/interface.constants';

export const ManageFlowProcess = ({ data, typeAction, isDisabled, isEdit, addedFlowProcess, t, action=false }) => {
    const [values, handleInputChange, handleDirectInputChange, setAllInfo] = useForm(EMPTY_ACTION);
    const [errorInputs, , resetErrors, validForm] = useErrorInputs({});
    const [selectedItem, setSelectedItem] = useState(null);
    const [openModal, setOpenModal] = useState(false);
    const [sendNotification] = useNotification();

    const currentFlowProcess = useMemo(() => {
        const parsed = safeParseJSON(data);
        if (Array.isArray(parsed))
            return parsed;
        if (Array.isArray(parsed?.flow_process))
            return parsed.flow_process;
        if (parsed && typeof parsed === 'object' && Object.keys(parsed).length > 0)
            return [parsed];
        return [];
    }, [data]);

    const handleOpenModal = (item = null) => {
        resetErrors();
        setSelectedItem(item);
        setAllInfo(item || EMPTY_ACTION);
        setOpenModal(true);
    };

    const handleCloseModal = () => {
        setOpenModal(false);
        resetErrors();
        setAllInfo(EMPTY_ACTION);
        setSelectedItem(null);
    };

    const handleSave = () => {
        saveIfValid(
            validForm(['accion', 'icon', 'color', 'type'], values),
            'Debe completar el formulario.'
        );
    };

const saveIfValid = (condition, errorMsg) => {
    if (condition) {
        if (typeAction === 'MENU') {
                const newFlowProcess = [...currentFlowProcess, values];
                addedFlowProcess('flow_process', newFlowProcess);
        } else {
                addedFlowProcess('flow_process', values);
        }
            handleCloseModal();
        } else
            sendNotification({ msg: errorMsg, variant: 'error' });
};
  return (
        <Box sx={{ width: '100%' }}>
            <Box sx={{pt: 2 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                    <Tooltip title={t(isEdit ? t('interface.editFlowProcess') : t('interface.addFlowProcess'))}>
                        <span>
                            <IconButton
                                disabled={isDisabled}
                                onClick={() => handleOpenModal()}
                                size="small"
                                sx={{ p: 0.5, height: 20 }}
                            >
                                {isEdit ? <EditNoteIcon /> : <SettingsInputComponentIcon />}
                            </IconButton>
                        </span>
                    </Tooltip>
                </Box>
            </Box>
            <Dialog open={openModal} fullWidth maxWidth='md' >
                <DialogTitle>
                    <Typography variant="h5" component="span">{t('interface.createEditFlowProcess')}</Typography>
                    <IconButton
                        onClick={handleCloseModal}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <Close />
                    </IconButton>
                </DialogTitle>

                <DialogContent>
                    <ManageActions
                        values={values}
                        errorInputs={errorInputs}
                        listActions={false}
                        data={selectedItem || {}}
                        handleInputChange={handleInputChange}
                        handleDirectInputChange={handleDirectInputChange}
                        handleCloseModal={handleCloseModal}
                        t={t}
                    />
                </DialogContent>
                <DialogActions>
                    <ActionButtons onSubmit={handleSave} onCancel={handleCloseModal} />
                </DialogActions>
            </Dialog>
        </Box>
    )
}
